import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useContext, useEffect, useState } from 'react';
import { Alert, Badge, Button, CloseButton, Col, Container, FloatingLabel, Form, Image, Row } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { LinkContainer } from 'react-router-bootstrap';
import { useLocation } from 'react-router-dom';
import { Link } from 'react-router-dom';
import ApiFetch from './ApiFetch';
import CampaignMessage from './CampaignMessage';
import Category from './Category';
import Dialog from './Dialog';
import FavoriteIcon from './FavoriteIcon';
import Footer from './Footer';
import Header from './Header';
import { useTranslation } from "react-i18next";
import RegistOrLogin from './RegistOrLogin';
import { LoginInfo } from '../App';
import { t } from 'i18next';
import * as RIcon from "react-icons/fa"
import Comment from './Comment';
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import Constants from './common/Constants';
import { Chip, Tooltip } from '@mui/material';

const Reply = (props) => {
    const location = useLocation()
    // ログイン情報
    const {loginInfo,setLoginInfo} = useContext(LoginInfo)
    const [bgColor,setBGColor] = useState("transparent")
    const [amountColor,setAmountColor] = useState("transparent")
    let comment = props.comment
    let i = props.i
    let imageInfo = props.imageInfo
    let dialog = props.dialog
    let groupId = props.groupId
    let upload = props.upload
    let selectItem = props.selectItem
    let setOkButtonShow = props.setOkButtonShow
    let type = props.type  || ""
    let postType = props.postType
    const amountBGColorList = [
        {"amount":200,"color":"#FFFFFF"}, // 200
        {"amount":500,"color":"#F3FEFB"}, // 500
        {"amount":1000,"color":"#FEFAED"}, // 1000-1500
        {"amount":2000,"color":"#FCF2EA"}, // 2000-2500
        {"amount":5000,"color":"#FBEBEF"}, // 5000-7500
        {"amount":10000,"color":"#FCE8E7"}, // 10000-50000
    ]
    const rainbowColors = [
        {color: "#00E5FF", amount: 200},
        {color: "#1DE9B6", amount: 500},
        {color: "#F7CA50", amount: 1000},
        {color: "#F7CA50", amount: 1500},
        {color: "#E68231", amount: 2000},
        {color: "#E68231", amount: 2500},
        {color: "#D63D65", amount: 5000},
        {color: "#D63D65", amount: 7500},
        {color: "#E62117", amount: 10000},
        {color: "#E62117", amount: 20000},
        {color: "#E62117", amount: 40000},
        {color: "#E62117", amount: 50000},  
    ]
	useEffect(() => {
        if(comment.amount > 0){
            let obj = amountBGColorList.reverse().find(d => d.amount <= comment.amount)
            setBGColor(obj.color)
            let colors = rainbowColors.find(d => d.amount === comment.amount)
            setAmountColor(colors.color)
        }
	},[comment])

    return(
        <div>
        <div style={{width:"auto",border:"1px solid #AAAAAA",backgroundColor:bgColor,borderRadius:"5px",textAlign:"left",padding:"10px",marginBottom:"10px",marginLeft:type === "reply-sub" ? "30px" : ""}} key={i}>
            <div className='d-flex justify-content-start'>
                <div>
                    <Link to={(comment.reply_user_is_character === 1 ? "/character/" : "/user/")+comment.reply_user_id}><Image data-no={i} className="replyLazy" loading="lazy" src={comment.reply_user_is_character === 1 ? ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/character/post/t/"+comment.reply_user_id+"_in.webp" : ApiFetch.API_PROTOCOL+"//"+ApiFetch.IMG_HOST+"/profile/"+comment.reply_user_id+"_s.jpg?"+comment.hash} style={{width:"50px",height:"50px",borderRadius:"25px",marginRight:"30px"}} /></Link>
                </div>
                <div style={{position:"relative",width:"100%"}}>
                    {(loginInfo.userId === imageInfo.info.user_id || loginInfo.userId === comment.reply_user_id) ? (
                        <CloseButton style={{position:"absolute",zIndex:"1",top:"0px",right:"20px"}} onClick={()=>{
                            selectItem({type:postType+"_reply",id:comment.comment_id})
                            setOkButtonShow(true)
                            dialog("確認","削除しますか？")
                        }} />
                    ) : ""}
                    <LinkContainer to={(comment.reply_user_is_character === 1 ? "/character/" : "/user/")+comment.reply_user_id} style={{fontSize:"14px",marginBottom:"5px",cursor:"pointer"}}><Container>{comment.reply_user_is_character === 1 ? <Tooltip title="AIによる自動返信" arrow><Chip label={<Icon.Robot />} /> </Tooltip> : ""}{comment.user_name}</Container></LinkContainer>
                    <Container style={{whiteSpace: "pre-wrap"}}>
                        {comment.amount > 0 ? <><span style={{backgroundColor:amountColor,borderRadius:"18px",fontSize:"12px",color:comment.amount >= 2000 ? "#FFFFFF" : "#000000"}} className='p-1'><MonetizationOnIcon style={{fontSize:"14px",color:comment.amount >= 2000 ? "#FFFFFF" : "#000000"}} /> {Constants.CURRENCY_UNIT_LEFT} {comment.amount.toLocaleString()}</span>&nbsp;</> : ""}
                        {comment.text}</Container>
                    {comment.stamp_id !== "" &&
                        <div>
                            {comment.stamp_del_flg === 0 ?
                                <Image loading="lazy" width="128px" height="128px" src={ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(comment.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT} className="zoom-stamp"
                                onMouseOver={(e) => {
                                    e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(comment.stamp_id)+ApiFetch.API_THUMB_EXT
                                }}
                                onMouseLeave={(e) => {
                                    e.currentTarget.src = ApiFetch.API_PROTOCOL+'//'+ApiFetch.IMG_HOST+'/stamp/'+(comment.stamp_id)+"_m"+ApiFetch.API_THUMB_EXT
                                }}
                                />
                                :
                                <p style={{width:"128px",height:"128px",border:"1px solid #000000",paddingTop:"50px"}} className="text-center">削除済スタンプ</p>
                            }
                        </div>
                    }
                    <Container className='d-block'>
                        <span style={{fontSize:"14px",color:"#555555"}}>{comment.post_datetime}</span>
                        <FavoriteIcon style={{cursor:"pointer",fontSize:"18px"}} type={postType+"_reply"} id={comment.comment_id} favorite={comment.favorite} count={comment.favorite_count} dialog={dialog} />
                        {comment.reply_user_is_character === 1 ? "" : <span style={{fontSize:"14px",color:"#555555",cursor:"pointer"}}
                            onClick={() => {
                                document.getElementById("reply-"+comment.comment_id).style.display = "block"
                            }}
                        >返信</span>}
                    </Container>
                    <Comment postType={postType} dialog={dialog} groupId={groupId} id={comment.comment_id} upload={upload} keyEvent={props.keyEvent} />
                </div>
            </div>
        </div>
    </div>
    )
}

export default Reply;
